<template>
  <div class="flex-grow xs:!w-full">
    <div v-if="tests.length > 0" class="bg-white mx-4 my-4 rounded-lg shadow-sm border">
      <div class="px-6 py-4 border-b border-gray-200">
        <h3 class="text-lg font-medium text-gray-900">Task Comments</h3>
        <p class="text-sm text-gray-500 mt-1">Comments from each farm in this task</p>
      </div>
      
      <div class="px-6 py-4 space-y-4">
        <div v-for="test in tests" :key="test.id" class="border-l-4 border-blue-200 pl-4 py-2">
          <div class="flex items-start justify-between">
            <div class="flex-grow">
              <h4 class="font-medium text-gray-900">{{ test.farm_name }}</h4>
              <p class="text-sm text-gray-600 mt-1" v-if="test.task_comment">
                {{ test.task_comment }}
              </p>
              <p class="text-sm text-gray-400 italic mt-1" v-else>
                No comment provided
              </p>
            </div>
            <div class="ml-4 flex-shrink-0">
              <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                {{ test.subtask_id }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div v-else class="bg-white mx-4 my-4 rounded-lg shadow-sm border">
      <div class="px-6 py-8 text-center">
        <div class="text-gray-400">
          <svg class="mx-auto h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
          </svg>
        </div>
        <h3 class="mt-2 text-sm font-medium text-gray-900">No tests available</h3>
        <p class="mt-1 text-sm text-gray-500">No comments to display.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tests: {
      type: Array,
      required: true,
      default: () => []
    },
    task: {
      type: Object,
      required: true
    }
  }
}
</script>